import { render, staticRenderFns } from "./bilan.vue?vue&type=template&id=bd606afe&scoped=true"
import script from "./bilan.vue?vue&type=script&lang=js"
export * from "./bilan.vue?vue&type=script&lang=js"
import style0 from "./bilan.vue?vue&type=style&index=0&id=bd606afe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd606afe",
  null
  
)

export default component.exports